import { type FragmentType, getFragmentData, graphql } from '../../../__generated__'
import { SentContent } from '../../../Components/SentContent/SentContent'
import { useReportSentData } from '../hooks'
import { SchoolSentCollapse } from './SchoolSentCollapse'

const fragments = {
  ReportSentFreeSchool_publicReportSource: graphql(`
    fragment ReportSentFreeSchool_publicReportSource on PublicReportSource {
      id
      sourceType

      ...useReportSentData_publicReportSource
    }
  `),
}

type ReportSentFreeSchoolProps = {
  publicReportSource: FragmentType<typeof fragments.ReportSentFreeSchool_publicReportSource>
}

export const ReportSentFreeSchool = ({
  publicReportSource: _publicReportSource,
}: ReportSentFreeSchoolProps) => {
  const publicReportSource = getFragmentData(
    fragments.ReportSentFreeSchool_publicReportSource,
    _publicReportSource
  )
  const { reportSentDescription } = useReportSentData(publicReportSource)
  return (
    <SentContent sourceType={publicReportSource.sourceType} description={reportSentDescription}>
      <SchoolSentCollapse />
    </SentContent>
  )
}
